import { hasSubscriptionLine } from './subscribeAndSave';
import type { ShoppingCartItem } from './type';

/** The Split flag that chooses the checkout. One name, so a typo cannot split the cohort across surfaces. */
export const CHECKOUT_SIMPLIFIED_FLAG = 'brandclub_dtc_checkout_simplified';

/**
 * The checkout route of a bag. Only `/checkout_simplified` enrolls a Subscribe & Save line, so a bag that holds one
 * always goes there. Otherwise the {@link CHECKOUT_SIMPLIFIED_FLAG} treatment decides, and any value but an
 * explicit opt-in means `/checkout`.
 */
export function pickCheckoutPath(
  treatment: string | undefined,
  carts: { items?: ShoppingCartItem[] }[],
): '/checkout' | '/checkout_simplified' {
  if (hasSubscriptionLine(carts)) return '/checkout_simplified';
  return treatment === 'on' || treatment === 'on_with_coupon' ? '/checkout_simplified' : '/checkout';
}
